import React, { Component } from "react";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../../../partials/layout/Avatar";
import { Image } from "react-bootstrap";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getLeads } from "../../../../services/crm/leadService";
import withGlobalData from "../../common/withGlobalData";
class SearchLead extends Component {
  state = {
    reload: this.props.globalData.reload,
    leads: [],
  };

  componentDidMount() {
    this.getLeads();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getLeads();
      this.setState({ reload: globalData.reload });
    }
  }

  async getLeads() {
    const response = await getLeads();
    const { data } = response.data;
    let leads = data.leads.filter(function(lead) {
      return lead.leadStatus === 1;
    });
    this.setState({ leads: leads });
  }

  render() {
    const { leads } = this.state;
    const { onSelectLead } = this.props;
    return (
      <CustomDataTableSearch
        data={leads}
        onRefreshData={() => {
          this.getLeads();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectLead(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectLead(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Lead ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Customer Group",
            field: "customerGroupName",
            body: null,
            sortable: true,
          },
          {
            header: "Lead Name",
            field: "leadName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.leadName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Contact Name",
            field: "contactName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.contactName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Phone Number",
            field: "contactPhone",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.contactPhone} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "City",
            field: "city",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.city} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Assigned To",
            field: "assignedUserName",
            body: (rowData) => (
              <React.Fragment>
                {rowData.assignedUserID !== 0 ? (
                  <React.Fragment>
                    {rowData.assignedUser.userImage ? (
                      <React.Fragment>
                        <div className="kt-widget4">
                          <div className="kt-widget4__item ">
                            <div className="kt-widget4__pic kt-widget4__pic--pic ">
                              <Image
                                src={
                                  rowData.assignedUser.userImage.length === 0
                                    ? createImageFromInitials(
                                        150,
                                        rowData.assignedUser.fullName,
                                        getRandomColor()
                                      )
                                    : rowData.assignedUser.userImage[0]
                                        .imagePath
                                }
                                roundedCircle
                                alt="Avatar"
                                style={{
                                  width: 32,
                                  height: 32,
                                }}
                              />
                            </div>
                            <div className="kt-widget4__info ">
                              <ResponsiveEllipsis
                                text={rowData.assignedUserName}
                                maxLine="1"
                              />
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ) : null}
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchLead);
